import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';

import { reportListing, sendListingToFriend } from './listing.api';

export const useReportListing = () =>
  useMutation({
    mutationFn: reportListing,
    onSuccess: () => {
      toast.success('Listing reported successfully');
    },
  });

export const useSendListingToFriend = () =>
  useMutation({
    mutationFn: sendListingToFriend,
    onSuccess: () => {
      toast.success('Message sent successfully!');
    },
  });
